import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  subtitle = 'From rec, club and community pickleball coaches running lessons, clinics and drop-ins.',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-navy' : 'bg-navy-deep';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-235" data-mp="2x0tgkgs46inb">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-236" data-mp="2x11ri34ofdvv">
        <div className="text-center" data-id="element-237" data-mp="2s2i1nrmyphy8">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-238" data-mp="2s3jjqg2eb4pg">
            Coach to coach
          </p>
          <h2 className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-239" data-mp="qalibvujz3sw">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-240" data-mp="h4wui1ce4aho">{subtitle}</p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-241" data-mp="m62p64pm27tu">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-navy-line bg-navy-card p-5 shadow-card" data-id="element-242" data-mp="79bnfosgsk12" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-243" data-mp="c7df2y3yhro5">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-244" data-mp="zwy3hwivph4t" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-[12px] font-bold text-white ring-2 ring-gold/50" aria-hidden="true" data-id="element-245" data-mp="v3d17sa960zt">
                    {getInitials(item.author)}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-246" data-mp="1sj5vjitgkx2e">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-247" data-mp="1og9jyc2c617y" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-248" data-mp="1ej4xsc8hq5r5">{item.quote}</blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-249" data-mp="19seqgtgi7stt">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-250" data-mp="19qv6arrq8xmr">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}
function getInitials(name: string) {
  const initials = name.split(/\s+/).map(part => part.replace(/[^A-Za-z]/g, '').charAt(0)).join('').slice(0, 2).toUpperCase();
  return initials || 'CR';
}